import { Button } from '@/components/ui/button';
import { Icon } from '@/lib/icons';
import { useApp } from '@/hooks/use-app-context';
import { useNavigate } from 'react-router-dom';

interface SessionNavProps {
  onPrev?: () => void;
  onNext?: () => void;
  onSubmit?: () => void;
  canPrev?: boolean;
  canSubmit?: boolean;
  isSubmitting?: boolean;
}

export function SessionNav({ onPrev, onNext, onSubmit, canPrev = false, canSubmit = true, isSubmitting = false }: SessionNavProps) {
  const { t, language } = useApp();
  const navigate = useNavigate();

  return (
    <section className="py-7">
      <div className="flex gap-4">
        {onPrev && (
          <Button
            variant="outline"
            onClick={onPrev}
            disabled={!canPrev}
            className="h-11 rounded-full border-border/40 px-5 text-sm font-semibold"
          >
            <Icon name="arrowLeft" className="mr-2 h-4 w-4" />
            {t.previous}
          </Button>
        )}
        {onSubmit && (
          <Button
            onClick={onSubmit}
            disabled={!canSubmit || isSubmitting}
            className="h-11 flex-1 rounded-full border border-primary/20 bg-primary px-5 text-sm font-semibold text-primary-foreground shadow-none transition-colors hover:bg-primary/90 disabled:border-border/30 disabled:bg-background/40 disabled:text-muted-foreground"
          >
            {isSubmitting ? (
              <Icon name="loader2" className="mr-2 h-4 w-4 animate-spin" />
            ) : (
              <Icon name="arrowRight" className="ml-auto h-4 w-4" />
            )}
            {isSubmitting ? t.loading : t.submit}
          </Button>
        )}
        {onNext && (
          <Button
            onClick={onNext}
            className="h-11 flex-1 rounded-full border border-primary/20 bg-primary px-5 text-sm font-semibold text-primary-foreground shadow-none transition-colors hover:bg-primary/90"
          >
            {t.submit}
            <Icon name="arrowRight" className="ml-2 h-4 w-4" />
          </Button>
        )}
        <Button
          variant="outline"
          onClick={() => navigate('/' + (language || 'fr') + '/admin/config/models')}
          className="h-11 rounded-full border-border/40 px-5 text-sm font-semibold"
        >
          <Icon name="home" className="h-4 w-4" />
        </Button>
      </div>
    </section>
  );
}
